import HomePage from "../features/home";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import JoinFooter from "../layout/sidenav/JoinFooter";

const Home = () => {
  return (
    <div>
      <Header page="home" color="white" />
      <HomePage />
      <JoinFooter />
      <Footer />
    </div>
  );
};

export default Home;
